import withStore from 'store/StoreContainer';
import {
  addUserAddresses,
  editUserAddresses,
  deleteUserAddresses,
  addressesSelector,
  countriesSelector,
  statesSelector,
  getCountries,
  getUserAddresses,
} from 'modules/dashboard/store';

const mapDispatchToProps = {
  addUserAddresses,
  editUserAddresses,
  deleteUserAddresses,
  getCountries,
  getUserAddresses,
};

const mapStateToProps = (state) => ({
  addresses: addressesSelector(state),
  countries: countriesSelector(state),
  states: statesSelector(state),
});

export default withStore(mapStateToProps, mapDispatchToProps);
